/**
 * @flow weak
 */


// Consts
export const SET_PROVIDER_KEY = 'SET_PROVIDER_KEY';
export const SET_CARD_INSTANCE = 'SET_CARD_INSTANCE';
export const SET_STRIPE_INSTANCE = 'SET_STRIPE_INSTANCE';
export const SET_STRIPE_STATUS = 'SET_STRIPE_STATUS';
export const UPDATE_CREDIT_CARD = 'UPDATE_CREDIT_CARD';
export const UPDATE_CREDIT_CARD_SUCCESS = 'UPDATE_CREDIT_CARD_SUCCESS';
export const UPDATE_CREDIT_CARD_ERROR = 'UPDATE_CREDIT_CARD_ERROR';

// Actions
export const setProviderKey = (key) => {
  return {
    type: SET_PROVIDER_KEY,
    payload: {
      key
    }
  };
};

export const setCardInstance = (card) => {
  return {
    type: SET_CARD_INSTANCE,
    payload: {
      card
    }
  };
};

export const setStripeInstance = (stripe) => {
  return {
    type: SET_STRIPE_INSTANCE,
    payload: {
      stripe
    }
  };
};

export const setStripeStatus = (status) => {
  return {
    type: SET_STRIPE_STATUS,
    payload: {
      status
    }
  };
};

export const updateCreditCard = (token) => {
  return {
    type: UPDATE_CREDIT_CARD,
    payload: {
      token
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/stripe/actions.js